// Header scroll shadow + scroll-to-top visibility
window.addEventListener('scroll', function(){
  var st = document.getElementById('scrollTop');
  if(st) st.classList.toggle('show', window.scrollY > 400);
});

// Mobile menu
function toggleMenu(){
  var menu = document.getElementById('mobileMenu');
  if(menu) menu.classList.toggle('open');
}

// Close mobile menu on outside click (but not on the hamburger itself)
document.addEventListener('click', function(e){
  var menu = document.getElementById('mobileMenu');
  var ham = document.getElementById('hamburger');
  if(menu && menu.classList.contains('open') && !menu.contains(e.target) && ham && !ham.contains(e.target)){
    menu.classList.remove('open');
  }
});

// FAQ accordion
function toggleFaq(el){
  var wasOpen = el.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open');});
  if(!wasOpen) el.classList.add('open');
}
